import { ImageCheck, LinkWrapper } from "Explore/Components";
import styles from "./FavoriteEntityItem.module.scss";
import { ImageCheckType } from "Explore/Config/ImageType";
import { IconButton } from "@mui/material";
import { IconPack } from "Explore/Config/Icons";
import classNames from "classnames";
import { numberRegex } from "Explore/Utils/numberRegex";
import useFavoriteItem from "Explore/Hook/useFavoriteItem";
import FavoriteSnackbar from "Explore/Hook/FavoriteItemSnackbar";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const FavoriteFacultyItem = ({ data }) => {
  const { deleteFavoriteItem, snackbarProps } = useFavoriteItem({
    itemId: data.id,
  });
  const [isDeleted, setIsDeleted] = useState(false);
  const statistics = [
    { value: data?.publication_count, icon: IconPack.publications },
    { value: data?.citation_count, icon: IconPack.citation },
    { value: data?.h_index, icon: IconPack.h_index },
    { value: data?.seniority, icon: IconPack.seniority },
  ].filter((e) => !!e.value);

  const handleDelete = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    const result = await deleteFavoriteItem();
    if (result) {
      setIsDeleted(true); // Triggers exit animation
    }
  };

  return (
    <>
      <AnimatePresence>
        {!isDeleted && (
          <motion.div
            initial={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
            style={{ width: "100%" }}
          >
            <LinkWrapper
              link={`/explore/faculty/${data?.explore_slug || data?.id}`}
              component={
                <div className={styles["container"]}>
                  <div className={styles["top"]}>
                    <div className={styles["avatar"]}>
                      <ImageCheck
                        url={data?.photo_url}
                        type={ImageCheckType.FACULTY_AVATAR}
                      />
                    </div>
                    <div className={styles["info"]}>
                      <div className={styles["name--wrapper"]}>
                        <p className={styles["name"]}>{data?.name}</p>
                        <IconButton
                          color="error"
                          size="small"
                          onClick={(e) => handleDelete(e)}
                        >
                          {IconPack.delete}
                        </IconButton>
                      </div>
                      <div className={styles["info__bottom"]}>
                        <p className={classNames(styles["position"], "dot-1")}>
                          {data?.position}
                        </p>
                        <p className={classNames(styles["inst-name"], "dot-1")}>
                          {data?.institution_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className={styles["statistics"]}>
                    {statistics.map((item, index) => (
                      <div className={styles["statistics--item"]} key={index}>
                        {item.icon}
                        {numberRegex(item.value)}
                      </div>
                    ))}
                  </div>
                  <div className={classNames(styles["bottom"])}>
                    <p className={classNames(styles["description"], "dot-3")}>
                      <span>RESEARCH AREA:</span>
                      <br />
                      {data?.keywords?.map(
                        (e, i) =>
                          `${e}${i !== data?.keywords?.length - 1 ? ", " : ""}`
                      )}
                    </p>
                  </div>
                </div>
              }
            />
          </motion.div>
        )}
      </AnimatePresence>
      <FavoriteSnackbar {...snackbarProps} />
    </>
  );
};

export default FavoriteFacultyItem;
